export const wfwLanguageList = [
  { id: 1, name: "Albanian", value: "al" },
  { id: 2, name: "Bangla", value: "bn" },
  { id: 3, name: "Chinese Pinyin", value: "cnp" },
  { id: 4, name: "Chinese Simplified", value: "cns" },
  { id: 5, name: "Chinese Traditional", value: "cnt" },
  { id: 6, name: "English", value: "en" },
  { id: 7, name: "French", value: "fr" },
  { id: 8, name: "German", value: "gr" },
  { id: 9, name: "Hindi", value: "hi" },
  { id: 10, name: "Indonesian", value: "in" },
  { id: 11, name: "Ingush", value: "ig" },
  { id: 12, name: "Malayalam", value: "ml" },
  { id: 13, name: "Persian", value: "pr" },
  { id: 14, name: "Russian", value: "ru" },
  { id: 15, name: "Sindhi", value: "sn" },
  { id: 16, name: "Tamil", value: "ta" },
  { id: 17, name: "Turkish", value: "tu" },
  { id: 18, name: "Urdu", value: "ur" },
];

